import '@/assets/jquery/jquery-ajax-blob-arraybuffer'
import saveAs from 'file-saver'
import Mgr from './SecurityService'
import 'babel-polyfill';
var user = new Mgr()

var isDevEnv = process.env.NODE_ENV == "development";

var services = {
    API_SYNC_DATA_ENPOINT: config.API_SYNC_DATA_ENPOINT,
    SERVICE_END_POINT: config.SERVICE_END_POINT,
    //TOKEN_END_POINT: config.TOKEN_END_POINT,
    API_END_POINT: config.API_END_POINT,
    REPORT_END_POINT: config.REPORT_END_POINT,
    REPORT_END_POINT_ORACLE_BIP: config.REPORT_END_POINT_ORACLE_BIP,
    REPORT_ORACLE_BIP_FOLDER: config.REPORT_ORACLE_BIP_FOLDER,
    USE_ORACLE_BI: config.USE_ORACLE_BI,
    clientId: 'TSC',
    clientSecret: 'b0udcdl8k80cqiyt63uq',
    getAccessToken: async function () {
        var accessToken;
        await user.getAcessToken().then(token => accessToken = token);

        return accessToken;
        //return JSON.parse(localStorage.getItem("_accessToken"));
    },
    //setAccessToken: function (token) {
    //    return localStorage.setItem("_accessToken", JSON.stringify(token));
    //},
    //clearAccessToken: function () {
    //    localStorage.removeItem("_accessToken");
    //},
    renewToken: async function () {
        await user.renewToken();
    },
    getAjaxOptions: async function () {
        var option = {
            //dataType: "json",
            contentType: 'application/json',//"application/x-www-form-urlencoded",
            cache: false,
            traditional: true,
            crossDomain: true,
            async: true,
            timeout: 600000
        };

        var accessToken = await this.getAccessToken();
        if (accessToken) {
            option.headers = {
                'Authorization': 'Bearer ' + accessToken
            };
        }

        return option;
    },
    request: function (requestType, url, data, options) {
        var self = this;
        var showErrorMsg = true;

        //// check token expiration
        //var token = self.getAccessToken();

        //if (token) {
        //    if (new Date(token['expires']) <= new Date() && token.refresh_token) {
        //        this.refreshToken(token.refresh_token);
        //    }
        //}

        if (url.indexOf('http') != 0) {
            url = this.API_END_POINT + url;
        }

        return $.Deferred(async function (defer) {
            var ajaxOptions = await self.getAjaxOptions();
            ajaxOptions.async = true;
            ajaxOptions.url = url;
            ajaxOptions.type = requestType;

            if (options) $.extend(ajaxOptions, options);

            if (ajaxOptions.type.toUpperCase() == 'GET') {
                ajaxOptions.data = data;
            } else if (ajaxOptions.contentType == 'application/json') {
                ajaxOptions.data = data ? JSON.stringify(data) : null;
            }
            $.ajax(ajaxOptions)
                .done(function (response, textStatus, xhr) {
                    defer.resolve(response, textStatus, xhr);
                })
                .fail(function (error) {
                    if (error.statusText == "timeout") {
                        if (showErrorMsg) {
                            alert('Operation timeout. Please try again later.');
                        }
                        console.log("Operation timeout. " + url);
                    } else {
                        if (showErrorMsg) {
                            if (error.responseJSON) {
                                alert(error.responseJSON.ExceptionMessage || error.responseJSON.Message || error.responseJSON.error
                                    || (typeof (error.responseJSON) == "string" ? error.responseJSON : JSON.stringify(error.responseJSON)));
                                console.log(error.responseJSON);
                            } else if (error.responseText) {
                                alert(error.responseText);
                            }
                        }
                    }

                    defer.reject(error);
                });
        });

    },

    get: function (url, data, options) {
        return this.request('GET', url, data, options);
    },
    post: function (url, data, options) {
        return this.request('POST', url, data, options);
    },
    put: function (url, data, options) {
        return this.request('PUT', url, data, options);
    },
    delete: function (url, data, options) {
        return this.request('DELETE', url, data, options);
    },
    // services
    //login: function (username, password) {
    //    var self = this;
    //    var data = {
    //        username: username,
    //        password: password,
    //        grant_type: 'password',
    //        client_id: this.clientId,
    //        client_secret: this.clientSecret
    //    };

    //    return $.ajax({
    //        type: 'POST',
    //        async: true,
    //        data: JSON.stringify(data),
    //        url: this.TOKEN_END_POINT,
    //        contentType: "application/json",
    //        dataType: 'Json',
    //        crossDomain: true,
    //        timeout: 300000
    //    }).done(function (token) {
    //        self.setAccessToken(token);
    //    });
    //},
    //refreshToken: function (refreshToken) {
    //    var self = this;
    //    // remove current access token
    //    self.clearAccessToken();

    //    // refresh the access token
    //    var data = {
    //        grant_type: 'refresh_token',
    //        refresh_token: refreshToken,
    //        client_id: this.clientId,
    //        client_secret: this.clientSecret
    //    };

    //    return $.ajax({
    //        type: 'POST',
    //        async: false,
    //        data: JSON.stringify(data),
    //        url: this.TOKEN_END_POINT,
    //        contentType: "application/json",
    //        dataType: 'Json',
    //        crossDomain: true,
    //        timeout: 300000
    //    }).done(function (token) {
    //        self.setAccessToken(token);
    //    });
    //},
    //logout: function () {
    //    var self = this;

    //    var accessToken = this.getAccessToken();

    //    // refresh the access token
    //    var data = {
    //        grant_type: 'invalidate_token',
    //        refresh_token: accessToken.refresh_token,
    //        client_id: this.clientId,
    //        client_secret: this.clientSecret,
    //        username: accessToken.username
    //    };

    //    self.clearAccessToken();
    //    return $.ajax({
    //        type: 'POST',
    //        async: true,
    //        data: JSON.stringify(data),
    //        url: this.TOKEN_END_POINT,
    //        contentType: "application/json",
    //        //dataType: 'Json',
    //        crossDomain: true,
    //        timeout: 300000
    //    }).done(function (token) {
    //    });
    //},
    upload: function (url, formData) {
        return this.post(url, null, {
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
        })
    },
    getResourceUrl: function (path) {
        if (path) {
            return this.SERVICE_END_POINT + "/" + this.STOREDCALLS_FOLDER + "/" + path.substring(this.EMAS_STOREDCALLS_FOLDER.length);
        } else {
            return '';
        }
    },
    getUploadResourceUrl: function (path) {
        if (path) {
            return this.SERVICE_END_POINT + "/" + this.UPLOADEDCALLS_FOLDER + "/" + path.substring(this.EMAS_UPLOADEDCALLS_FOLDER.length);
        } else {
            return '';
        }
    },
    encodeURIComponent: function (obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    },
    download: function (url, data) {
        var self = this;
        return this.get(url, data, {
            contentType: 'application/octet-stream; charset=UTF-8',
            dataType: 'arraybuffer'
        }).done(function (data, textStatus, xhr) {
            self.saveFile(data, xhr);
        });

        //var self = this;
        //return this.get(url, null, {
        //    contentType: 'application/octet-stream; charset=UTF-8',
        //    dataType: 'arraybuffer'
        //}).done(function (data, textStatus, xhr) {
        //    self.saveFile(data, xhr);
        //});
    },
    download2: function (url, data) {
        var self = this;
        return this.get(url, data, {
            contentType: 'application/octet-stream; charset=UTF-8',
            dataType: 'arraybuffer'
        }).done(function (data, textStatus, xhr) {
            self.saveFile(data, xhr);
        });
    },
    saveFile(data, xhr) {
        var blob = new Blob(
            [data],
            { type: xhr.getResponseHeader('content-type') }
        );
        var fileName = xhr.getResponseHeader('Filename');
        saveAs(blob, decodeURIComponent(escape(fileName)));
    },
    getOracleBIPUrl(reportPath, reportName, parameter) {
        return `${this.REPORT_END_POINT_ORACLE_BIP}/xmlpserver/${this.REPORT_ORACLE_BIP_FOLDER}/${reportPath}.xdo?_xpf=&_xpt=0&_dFlag=false&_edIndex=0&_dIndex=0&_rToken=&_ranDiag=false&_xdo=%2F${this.REPORT_ORACLE_BIP_FOLDER}%2F${reportPath}.xdo&_xmode=3&_paramsparameter=${encodeURI(JSON.stringify(parameter))}&_xt=${reportName}&_xf=html`;
    }
};

export default services;
